export default "__VITE_ASSET__BJzE1GUt__"